const ValidationErrors = ({ errors, className }) => {
  return (
    <div className={`text-red-500 text-xs text-left ${className}`}>
      {errors}
    </div>
  );
};
export default ValidationErrors;
